// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"33bdac2e","400":"f0557c28","453":"74e1333a","460":"af38561f","598":"b79c26e5"}[chunkId] + ".chunk.js";
};